import React from "react";
import Select, { components } from "react-select";
import { BsChevronDown } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";

const DropdownIndicator = props => (
	<components.DropdownIndicator {...props}>
		<BsChevronDown />
	</components.DropdownIndicator>
);

const ClearIndicator = props => (
	<components.ClearIndicator {...props}>
		<IoMdClose size="12px" />
	</components.ClearIndicator>
);

export const SearchSelectInput = ({
	id,
	placeholder,
	options,
	onChange,
	onInputChange,
	isMulti = false,
	isClearable = true,
	isDisabled = false,
	value
}) => {
	const handleInputChange = (inputValue, { action }) => {
		if (action === "input-change") {
			onInputChange(inputValue);
		}
	};

	const handleChange = selectedOption => {
		onChange(selectedOption);
	};

	const customStyles = {
		control: (provided, state) => ({
			...provided,
			minHeight: "48px",
			height: "48px"
		}),
		valueContainer: (provided, state) => ({
			...provided,
			height: "48px",
			padding: "0 6px"
		}),
		input: (provided, state) => ({
			...provided,
			margin: "0px"
		}),
		indicatorsContainer: (provided, state) => ({
			...provided,
			height: "48px"
		})
	};

	return (
		<Select
			classNamePrefix="react-select"
			inputId={id}
			isMulti={isMulti}
			isClearable={isClearable}
			components={{ DropdownIndicator, ClearIndicator }}
			placeholder={placeholder}
			options={options}
			onInputChange={handleInputChange}
			onChange={handleChange}
			value={value}
			styles={customStyles}
			isDisabled={isDisabled}
		/>
	);
};

export default SearchSelectInput;
